import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IPaginatedServiceResponse } from '@/data/models/ServiceResponse'
import { IChart } from '@/data/models/Chart'

export class ChartApiService extends ApiService {
  /**
   * Returns paginated list of Charts
   */
  static async getCharts(params: object): Promise<IPaginatedServiceResponse<IChart>> {
    return this.axios.get('charts', {
      params
    }).then((response: AxiosResponse<IPaginatedServiceResponse<IChart>>) => response.data)
  }
}
